/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiPipelineRuntime
 */
export interface ApiPipelineRuntime {
  /**
   * Output. The runtime JSON manifest of the pipeline, including the status
   * of pipeline steps and fields need for UI visualization etc.
   * @type {string}
   * @memberof ApiPipelineRuntime
   */
  pipeline_manifest?: string;
  /**
   * Output. The runtime JSON manifest of the argo workflow.
   * This is deprecated after pipeline_runtime_manifest is in use.
   * @type {string}
   * @memberof ApiPipelineRuntime
   */
  workflow_manifest?: string;
}

/**
 * Check if a given object implements the ApiPipelineRuntime interface.
 */
export function instanceOfApiPipelineRuntime(value: object): value is ApiPipelineRuntime {
  return true;
}

export function ApiPipelineRuntimeFromJSON(json: any): ApiPipelineRuntime {
  return ApiPipelineRuntimeFromJSONTyped(json, false);
}

export function ApiPipelineRuntimeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPipelineRuntime {
  if (json == null) {
    return json;
  }
  return {
    pipeline_manifest: json['pipeline_manifest'] == null ? undefined : json['pipeline_manifest'],
    workflow_manifest: json['workflow_manifest'] == null ? undefined : json['workflow_manifest'],
  };
}

export function ApiPipelineRuntimeToJSON(json: any): ApiPipelineRuntime {
  return ApiPipelineRuntimeToJSONTyped(json, false);
}

export function ApiPipelineRuntimeToJSONTyped(
  value?: ApiPipelineRuntime | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipeline_manifest: value['pipeline_manifest'],
    workflow_manifest: value['workflow_manifest'],
  };
}
